abstract class Storage {
  static get<T>(key: string): T | null {
    return null;
  }

  static set<T>(key: string, value: T): void {}

  static remove(key: string): void {}

  static clear(): void {}
}

export default Storage;
